export default {
    memberPoint: {
        method: 'GET',
        url: '/admin/sysConfig/memberPoint',
        name: '获得会员积分基本配置'
    },
    updateMemberPoint: {
        method: 'PUT',
        url: '/admin/sysConfig/memberPoint',
        name: '保存会员积分基础配置'
    },
    getShopLimit: {
        method: 'GET',
        url: '/admin/sysConfig/shopLimit/{shopId}',
        name: '获得场地限制配置'
    },
    updateShopLimit: {
        method: 'PUT',
        url: '/admin/sysConfig/shopLimit',
        name: '保存场地限制配置'
    },
    memberList: {
        method: 'POST',
        url: '/admin/gradeConfig/list',
        name: '会员等级列表'
    },
    addConfig: {
        method: 'POST',
        url: '/admin/gradeConfig',
        name: '新增会员等级'
    },
    updatememberList: {
        method: 'PUT',
        url: '/admin/gradeConfig',
        name: '编辑会员等级'
    },
    memberSelectList: {
        method: 'GET',
        url: '/admin/gradeConfig/selectList',
        name: '会员等级下拉列表'
    },
    recordList: {
        method: 'POST',
        url: '/manage-system/user/point/page',
        name: '会员积分列表'
    },
}